import React from 'react';
import Icon from '../../../components/AppIcon';

const PortfolioHeatMap = ({ data, title }) => {
  const getHeatMapColor = (riskLevel) => {
    switch (riskLevel) {
      case 'high':
        return 'bg-error text-error-foreground';
      case 'medium':
        return 'bg-warning text-warning-foreground';
      case 'low':
        return 'bg-success text-success-foreground';
      default:
        return 'bg-muted text-muted-foreground';
    }
  };

  const getSize = (allocation) => {
    if (allocation > 20) return 'w-24 h-16';
    if (allocation > 10) return 'w-20 h-14';
    if (allocation > 5) return 'w-16 h-12';
    return 'w-12 h-10';
  };

  return (
    <div className="bg-card border border-border rounded-lg p-6">
      <div className="flex items-center justify-between mb-4">
        <h3 className="text-lg font-semibold text-foreground">{title}</h3>
        <div className="flex items-center space-x-4 text-xs">
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-success rounded"></div>
            <span>Low Risk</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-warning rounded"></div>
            <span>Medium Risk</span>
          </div>
          <div className="flex items-center space-x-1">
            <div className="w-3 h-3 bg-error rounded"></div>
            <span>High Risk</span>
          </div>
        </div>
      </div>
      <div className="grid grid-cols-8 gap-2">
        {data?.map((item) => (
          <div
            key={item?.symbol}
            className={`${getSize(item?.allocation)} ${getHeatMapColor(item?.riskLevel)} rounded-md p-2 flex flex-col justify-between transition-all hover:scale-105 cursor-pointer`}
            title={`${item?.symbol}: ${item?.allocation}% allocation, ${item?.riskLevel} risk`}
          >
            <div className="text-xs font-medium truncate">{item?.symbol}</div>
            <div className="text-xs">{item?.allocation}%</div>
            {item?.alert && (
              <Icon name="AlertTriangle" size={12} className="self-end" />
            )}
          </div>
        ))}
      </div>
      <div className="mt-4 pt-4 border-t border-border">
        <div className="grid grid-cols-3 gap-4 text-sm">
          <div>
            <span className="text-muted-foreground">Total Positions:</span>
            <span className="ml-2 font-medium text-foreground">{data?.length}</span>
          </div>
          <div>
            <span className="text-muted-foreground">High Risk:</span>
            <span className="ml-2 font-medium text-error">
              {data?.filter(item => item?.riskLevel === 'high')?.length}
            </span>
          </div>
          <div>
            <span className="text-muted-foreground">Alerts:</span>
            <span className="ml-2 font-medium text-warning">
              {data?.filter(item => item?.alert)?.length}
            </span>
          </div>
        </div>
      </div>
    </div>
  );
};

export default PortfolioHeatMap;